import { api } from './api';

export interface TriggerInfo { key: string; label: string; fields: string[]; }
export interface ActionInfo { type: string; label: string; params: string[]; }
export interface RuleTemplate { name: string; triggerKey: string; conditionsJson: string; actionsJson: string; description: string; }
export interface Catalogue { triggers: TriggerInfo[]; actions: ActionInfo[]; templates: RuleTemplate[]; }

export interface Rule {
  id: string; name: string; triggerKey: string; isActive: boolean;
  conditionsJson: string; actionsJson: string;
  lastFiredAt: string | null; fireCount: number; updatedAt: string;
}

export interface Run {
  id: string; ruleName: string; triggerKey: string; success: boolean; summary: string; ranAt: string;
}

export interface UpsertRule { name: string; triggerKey: string; conditionsJson: string; actionsJson: string; }

export const automationApi = {
  catalogue: () => api.get<Catalogue>('/api/automation/catalogue'),
  rules: () => api.get<Rule[]>('/api/automation/rules'),
  create: (b: UpsertRule) => api.post<Rule>('/api/automation/rules', b),
  update: (id: string, b: UpsertRule) => api.put<Rule>(`/api/automation/rules/${id}`, b),
  setActive: (id: string, active: boolean) => api.post<Rule>(`/api/automation/rules/${id}/${active ? 'activate' : 'deactivate'}`, {}),
  runs: (take = 50) => api.get<Run[]>(`/api/automation/runs?take=${take}`),
};
